module.exports = __webpack_public_path__ + "img/collection-diamondJewelryRosegold.5cf97ab.jpg";